// extracted by mini-css-extract-plugin
export default {"body":"CompletedClassesAccordion_body__nbMml"};